import { parseNameForSearch } from '@common/utils/parseNameForSearch';
import { UrlBuilder } from '@common/utils/urlBuilder';

// eslint-disable-next-line max-params-no-constructor/max-params-no-constructor
export function buildLoadOrganizationsPractitionersUrl(
    searchInput?: string,
    city?: string,
    page?: string,
    itemsPerPage?: number
) {
    const urlBuilder = new UrlBuilder('/api/organizations/organizationsPractitioners');
    urlBuilder.add('practitionerIsActivated', true);
    urlBuilder.add('organizationIsActive', true);
    if (searchInput) {
        urlBuilder.add('searchText', parseNameForSearch(searchInput));
    }
    if (city) {
        urlBuilder.add('searchCity', city);
    }
    if (page) {
        urlBuilder.add('page', page);
        urlBuilder.add('limit', itemsPerPage || 10);
    }

    return urlBuilder.build();
}
